/* eslint-disable no-param-reassign */
import {
  Select,
  Option,
  OptionGroup,
  Checkbox,
  Input,
  Tooltip,
  Message,
  MessageBox,
  DatePicker,
  Notification,
  Table,
  TableColumn,
  Pagination,
  Popover,
  Drawer,
  Loading,
  Radio,
  RadioGroup,
  RadioButton,
  Button,
  TabPane,
  Divider,
  Collapse,
  CollapseItem,
  Alert,
  Tabs,
  Autocomplete,
  Badge,
  Link,
  Steps,
  Step,
  Row,
  Col,
  Carousel,
  CarouselItem,
  Upload,
  Dialog,
  InputNumber,
  Transfer,
} from 'element-ui';
import element from '@/i18n';
import '@/assets/element-ui/theme/index.css';
import '@/assets/element-ui/theme/custom.css';
import locale from 'element-ui/lib/locale';

locale.use(element.es.element);

export default ({ Vue }) => {
  Vue.use(Select, { locale });
  Vue.use(Option, { locale });
  Vue.use(OptionGroup, { locale });
  Vue.use(Checkbox, { locale });
  Vue.use(Input, { locale });
  Vue.use(Tooltip, { locale });
  Vue.use(DatePicker, { locale });
  Vue.use(Table, { locale });
  Vue.use(TableColumn, { locale });
  Vue.use(Pagination, { locale });
  Vue.use(Popover, { locale });
  Vue.use(Drawer, { locale });
  Vue.use(Loading, { locale });
  Vue.use(Radio, { locale });
  Vue.use(RadioGroup, { locale });
  Vue.use(RadioButton, { locale });
  Vue.use(Button, { locale });
  Vue.use(TabPane, { locale });
  Vue.use(Divider, { locale });
  Vue.use(Collapse, { locale });
  Vue.use(CollapseItem, { locale });
  Vue.use(Alert, { locale });
  Vue.use(Tabs, { locale });
  Vue.use(TabPane, { locale });
  Vue.use(Autocomplete, { locale });
  Vue.use(Badge, { locale });
  Vue.use(Link, { locale });
  Vue.use(Steps, { locale });
  Vue.use(Step, { locale });
  Vue.use(Upload, { locale });
  Vue.use(Row, { locale });
  Vue.use(Col, { locale });
  Vue.use(Carousel, { locale });
  Vue.use(CarouselItem, { locale });
  Vue.use(Upload, { locale });
  Vue.use(Dialog, { locale });
  Vue.use(InputNumber, { locale });
  Vue.use(Transfer, { locale });

  Vue.prototype.$msgbox = MessageBox;
  Vue.prototype.$alert = MessageBox.alert;
  Vue.prototype.$confirm = MessageBox.confirm;
  Vue.prototype.$prompt = MessageBox.prompt;
  Vue.prototype.$notify = Notification;
  Vue.prototype.$message = Message;
};



// WEBPACK FOOTER //
// ./src/plugins/element.js